import william from "../mo";

/**
 *
 * @param a
 * @return {*}
 */
export const identity = a => a;

/*
 * UTILITIES
 */

/**
 *
 * @param source
 * @param keys
 * @param val
 */
export const deepUpdate = (source, keys, val) => {
  if (keys.length === 1) {
    source[keys[0]] = val;
    return;
  }
  deepUpdate(source[keys[0]], keys.slice(1), val);
};

/**
 *
 * @param a
 * @returns {*}
 */
export const logSimple = a => {
  console.log(cheapoClone(a));
  return a;
};

/**
 *
 * @param source
 * @param keys
 * @returns {*}
 */
export const deepGet = (source, keys) => {
  if (!source) return null;
  if (keys.length === 1) return source[keys[0]];
  return deepGet(source[keys[0]], keys.slice(1));
};

/**
 *
 * @param a
 * @returns {*}
 */
export const normalizeComparableValue = a => {
  switch (typeof a) {
    case "number":
      return a;
    case "string":
      return a.toLowerCase();
    case "boolean":
      return a ? 1 : -1;
    case "undefined":
      return 1;
    default:
      return a;
  }
};

/**
 *
 * @param keys
 * @returns {function(*=): *}
 */
export const deepGetKeysC = keys => {
  return source => deepGet(source, keys);
};

/**
 * Parametrizes extractor on key
 * @param {string} key
 * @returns {function(*): any[]}
 */
export const extractUniqueBy = key => arr => {
  return Object.values(
    arr.reduce((acc, i) => {
      if (typeof acc[i[key]] !== "undefined") return acc;
      acc[i[key]] = i;
      return acc;
    }, {})
  );
};

export const NC_KEY_NAME = "Non communiqué";
export const NC_SLUG_NAME = "non-communique";

/**
 *
 * @type {function(*): any[]}
 */
export const extractUniqueById = extractUniqueBy("id");
/**
 *
 * @type {function(*): any[]}
 */
export const extractUniqueByUuid = extractUniqueBy("uuid");

/**
 * Basic ids + items structure
 * @returns {{ids: {}, items: Array}}
 * @constructor
 */
export const MemoizedIdsIndexList = () => ({ ids: {}, items: [] });

/**
 * Transform a list of objects having ids into a memoized list
 * @param list
 * @returns {MemoizedIdsIndexList}
 */
export const memoizeIdIndexList = list =>
  list.reduce((acc, row) => {
    if (typeof acc.ids[row.id] !== "undefined") return acc;
    acc.ids[row.id] = acc.items.length;
    acc.items.push(row);
    return acc;
  }, MemoizedIdsIndexList());

/**
 *
 * @type {{Démolition: number, Reconstruction: number, Livraison: number}}
 */
export const programWeightMap = {
  Démolition: -1,
  Reconstruction: 1,
  Livraison: 1
};

/**
 * @param programs
 */
export const sortProgrammes = programs => {
  return programs.sort((b, a) => a[programWeightMap] || 0);
};

/**
 *
 * @param dateLikeStr
 * @return {*}
 */
export const extractYear = dateLikeStr => {
  if (!dateLikeStr) return dateLikeStr;
  const matches = dateLikeStr.match(/(\d{4,})/);
  if (!matches) return "";
  return matches[1];
};

/**
 * @param {array} ids
 * @param {MemoizedIdsIndexList} list
 */
export const fetchItemsByIdFromMemoizedList = (ids, list) => {
  const out = [];
  for (let id of ids) {
    if (typeof list.ids[id] !== "undefined") {
      out.push(list.items[list.ids[id]]);
    }
  }
  return out;
};

/**
 * Dedupes a simple primitive array
 * @param {array} arr
 * @returns {array}
 */
export const dedupe = arr =>
  arr.reduce((acc, i) => {
    if (acc.indexOf(i) === -1) acc.push(i);
    return acc;
  }, []);

/**
 *
 * @param ids
 * @param list
 * @returns {Array}
 */
export const fetchItemsByIdFromMemoizedListDedupe = (ids, list) =>
  fetchItemsByIdFromMemoizedList(dedupe(ids), list);

/**
 *
 * @param interlocuteurs
 * @returns {{partners: *}[]}
 */
export const morphInterlocuteursToTableView = (
  interlocuteurs,
  interlocuteurs_d
) => {
  const { roles, partners, contacts } = interlocuteurs_d.reduce(
    (acc, line) => {
      acc.roles.push(line.role);
      acc.partners.push(line.partner);
      if (line.contact.still_working === 1) {
        acc.contacts.push(line.contact);
      }
      return acc;
    },
    { roles: [], partners: [], contacts: [] }
  );
  const mRoles = memoizeIdIndexList(roles);
  const mPartners = memoizeIdIndexList(partners);
  const mContacts = memoizeIdIndexList(contacts);
  return mRoles.items.map(role => {
    const partners = fetchItemsByIdFromMemoizedListDedupe(
      interlocuteurs.filter(i => i.role_id === role.id).map(i => i.partner_id),
      mPartners
    ).map(partner => {
      const contacts = fetchItemsByIdFromMemoizedListDedupe(
        interlocuteurs
          .filter(i => i.partner_id === partner.id && i.role_id === role.id)
          .map(i => i.contact_id),
        mContacts
      );
      return {
        ...partner,
        contacts
      };
    });
    return {
      ...role,
      partners
    };
  });
};

/**
 *
 * @param arr
 * @param accessor
 * @param sorter
 * @returns {T[] | string | T[]}
 */
export const sortAndTailNulls = (arr, accessor, sorter) => {
  const { nulls, nonNulls } = arr.reduce(
    (obj, item) => {
      if (accessor(item) === null) obj.nulls.push(item);
      else obj.nonNulls.push(item);
      return obj;
    },
    { nulls: [], nonNulls: [] }
  );
  const s = nonNulls.slice(0).sort(sorter);
  return s.concat(nulls);
};

export const tail = arr => arr[arr.length - 1];
export const toTail = arr => arr.slice(0, arr.length - 1);
export const toKeys = str => str.split(".");

/**
 * @param router VueRouter
 * @returns {*}
 */
export const setSaveState = router => router.push({ query: { s: 1 } });

/**
 *
 * @param a
 * @returns {any}
 */
export const cheapoClone = a => JSON.parse(JSON.stringify(a));

/**
 * Logs then returns its argument
 * @param a
 */
export const log = a => {
  // eslint-disable-next-line
  console.log(a);
  return a;
};

/**
 *
 * @param money
 * @returns {string}
 */
export const formatNumbers = money => {
  if (!money) return "";
  if (money.toString() === 0 || money.toString().length < 3) return money;
  return money
    .toString()
    .split("")
    .reverse()
    .reduce(
      (acc, digit) => {
        if (acc[acc.length - 1].length < 3) acc[acc.length - 1].push(digit);
        else acc.push([digit]);
        return acc;
      },
      [[]]
    )
    .reverse()
    .map(pack => pack.reverse().join(""))
    .join(" ");
};

/**
 *
 * @param money
 * @return {string}
 */
export const formatNumbersFrench = money =>
  money < 10 ** 6
    ? formatNumbers(money)
    : parseFloat((money / 10 ** 6).toFixed(2)) + "M";

/**
 *
 * @param {array} arr
 * @param {function} fn
 * @returns {boolean}
 */
export const anyShortCircuit = (arr, fn) => {
  const l = arr.length;
  for (let i = 0; i < l; i++) {
    if (fn(arr[i])) return true;
  }
  return false;
};

/**
 *
 * @param {number} val
 * @param {array} arr
 * @returns {boolean}
 */
export const outOfBounds = (val, arr) => val < 0 || val > arr.length - 1;

/**
 * Consumes its argument, noops.
 * @param error
 */
// eslint-disable-next-line
export const silence = error => {};

/**
 *
 * @param {string} number
 * @param {string|null} cur
 * @param {string|null} rest
 * @param {array} result
 * @returns {*}
 */
export const cleanPhoneNumber = (
  number,
  cur = null,
  rest = null,
  result = null
) => {
  if (!number) return [];
  if (rest === null || cur === null) {
    cur = number[0];
    rest = number.slice(1);
    result = [];
  }
  if (/\+/.test(cur)) result.push("+");
  if (/\d/.test(cur)) result.push(cur);
  if (rest.length === 0) return result;
  return cleanPhoneNumber(number, rest[0], rest.slice(1), result);
};

/**
 *
 * @param pn
 * @returns {string | *}
 */
export const displayPhoneNumber = pn => pn.join("");

/**
 *
 * @param width
 * @param height
 * @param aspectRatio
 * @param landscape
 * @param portrait
 * @returns {{width: (*|number), aspectRatio: (*|number), portrait: (*|boolean), landscape: (*|boolean), height: (*|number)}}
 * @constructor
 */
export const ImageDimensions = ({
  width,
  height,
  aspectRatio,
  landscape,
  portrait
}) => ({
  width: width || 0,
  height: height || 0,
  aspectRatio: aspectRatio || 0,
  landscape: landscape || false,
  portrait: portrait || false
});

/**
 * Takes an image el, returns dimensional metadata.
 * @param {HTMLImageElement} image
 * @return {ImageDimensions} dimensions
 */
export const handleImageDimensions = image => {
  const width = image.naturalWidth;
  const height = image.naturalHeight;
  const aspectRatio = width / height;
  return ImageDimensions({
    width,
    height,
    aspectRatio,
    landscape: aspectRatio > 1,
    portrait: aspectRatio <= 1
  });
};

/**
 *
 * @type {RegExp}
 */
export const authRoutesRegex = /(auth|login|forgot)/;

/**
 *
 * @type {RegExp}
 */
export const printRoutesRegex = /(print|fiche_projet|index_projet|agence_about|summary|kit_presse|fichettes)/;

/**
 * Noop.
 */
export const noop = () => {};

export const download = (filename, text) => {
  const element = document.createElement("a");
  element.setAttribute(
    "href",
    "data:text/plain;charset=utf-8," + encodeURIComponent(text)
  );
  element.setAttribute("download", filename);

  element.style.display = "none";
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
};

/**
 *
 * @param e
 * @param el
 * @return {{too_large: boolean, too_high: boolean}}
 */
export const handleImageLoad = (e, el) => {
  const imageRatio = e.target.naturalWidth / e.target.naturalHeight;
  const { width, height } = el.querySelector(".Inner").getBoundingClientRect();
  const containerRatio = width / height;
  if (imageRatio > containerRatio) {
    return { too_large: true, too_high: false };
  }
  if (imageRatio <= containerRatio) {
    return { too_large: false, too_high: true };
  }
};

/**
 *
 * @param a
 * @returns {*}
 */
export const unbreakable = a => william.format(a);

/**
 *
 * @param arr
 * @return {string | *}
 */
export const mapNames = arr => {
  return arr.map(a => (a.name ? a.name : "")).join(", ");
};

/**
 *
 * @param date
 * @param dates
 * @return {*}
 */
export const getDate = (date, dates) => {
  return dates.find(d => d.text === date);
};

/**
 *
 * @param role
 * @param interlocuteurs_d
 * @returns {number | never | bigint | T | T | *}
 */
export const getEntrBySlug = (role, interlocuteurs_d) => {
  return interlocuteurs_d.find(a => a.role.slug === role);
};

/**
 *
 * @param role
 * @param interlocuteurs_d
 * @returns {*}
 */
export const getDistinctArrBySlug = (role, interlocuteurs_d) => {
  return interlocuteurs_d.reduce(
    (b, a) => {
      if (role !== a.role.slug) return b;
      if (b.set[a.partner.name]) return b;
      b.set[a.partner.name] = 1;
      b.items.push(a);
      return b;
    },
    { set: {}, items: [] }
  ).items;
};

/**
 *
 * @param str
 * @param interlocuteurs_d
 * @returns {*}
 */
export const getEntrNamesBySlugMatching = (str, interlocuteurs_d, exclude = null) => {
    let out =  interlocuteurs_d
    .filter(a => a.role.slug.indexOf(str) !== -1);
    if (exclude) {
      out = out.filter(a => a.role.slug.indexOf(exclude) === -1);
    }
    return out.map(p => p.partner.name)
    .reduce((b, a) => {
      if (b.indexOf(a) !== -1) return b;
      b.push(a);
      return b;
    }, []);
};

/**
 *
 * @param str
 * @returns {string}
 */
export const filterScalene = str => str.replace("scalène", "scalene");

/**
 *
 * @param date
 * @returns {string}
 */
export const formatDate = date => {
  return date
    .split("-")
    .reverse()
    .join("/");
};

const MONTHS = [
  "Janvier",
  "Février",
  "Mars",
  "Avril",
  "Mai",
  "Juin",
  "Juillet",
  "Août",
  "Septembre",
  "Octobre",
  "Novembre",
  "Décembre"
];

export const formatDateFrench = dateLikeStr => {
  if (typeof dateLikeStr !== "string" || dateLikeStr.length !== 10)
    return dateLikeStr;
  const parts = dateLikeStr.split("-");
  return `${MONTHS[parseInt(parts[1], 10) - 1] || ""} ${parts[0]}`;
};

/**
 *
 * @type {string}
 */
export const DRAWING_SPACE_MOVED = "DRAWING_SPACE_MOVED";

/**
 *
 * @return {{top: number, left: number, bottom: number, width: number, x: number, y: number, right: number, height: number}}
 */
export const dRect = () => ({
  bottom: 0,
  height: 0,
  left: 0,
  right: 0,
  top: 0,
  width: 0,
  x: 0,
  y: 0
});

export const numToBullet = num => (num === 0 ? 9450 : num + 9311);

/**
 *
 * @param img
 * @return {{width: number, height: *}}
 */
export const objectFitImageRealDims = img => {
  if (!img) return { width: 0, height: 0 };
  const ratio = img.naturalWidth / img.naturalHeight;
  let width = img.height * ratio;
  let height = img.height;
  if (width > img.width) {
    width = img.width;
    height = img.width / ratio;
  }
  return { width, height };
};

export const getArchitectes = project => {
  return getEntrNamesBySlugMatching("architecte", project.interlocuteurs_d);
};

export const getArchitectesWithMandataireDistinction = project => {
  return project.interlocuteurs_d
    .filter(i => i.role.slug.indexOf("architecte") !== -1)
    .map(line => {
      if (line.role.slug.indexOf("mandataire") !== -1)
        return `${line.partner.name} (m.)`;
      return line.partner.name;
    })
    .reduce((b, a) => (b.indexOf(a) === -1 ? b.concat([a]) : b), []);
};

export const getAmenageurs = project => {
  return getEntrNamesBySlugMatching("amenageur", project.interlocuteurs_d);
};

export const getMaitrise = project => {
  return getEntrNamesBySlugMatching("maitre", project.interlocuteurs_d, "execution");
};

export const getUser = project => {
  return getEntrNamesBySlugMatching("utilisateur", project.interlocuteurs_d);
};

export const getLatestDate = project => {
  if (project.dates_d.length === 0) return false;
  const b = project.dates_d
    .slice(0)
    .sort((b, a) =>
      extractYear(b.content) > extractYear(a.content) ? -1 : 1
    )[0];
  return b;
};

export const getBiggestSurface = project => {
  if (project.surfaces.length === 0) return false;
  const b = project.surfaces
    .slice(0)
    .sort((b, a) => (b.content > a.content ? -1 : 1))[0];
  return b;
};
